export const COMMON_API_URL = 'https://api.ellow.io'
export const REACT_APP_RECRUITER = '/recruiter/api/v1/ml'
export const REACT_APP_JOB = '/job/api/v1/ml'
export const REACT_APP_CANDIDATE_FREELANCER= '/candidate-freelancer/api/v1/ml'
export const REACT_APP_CUSTOMER = '/Customer/api/v1/ml'
export const REACT_APP_CANDIDATE = '/candidate/api/v1/ml'
export const REACT_APP_PROFILE = '/profile/api/v1/ml'
export const REACT_APP_CUSTOMERSETTINGS = '/customersettings/api/v1/ml'
export const REACT_APP_CONTRACT = '/contract/api/v1/ml'
export const REACT_APP_CANDIDATEFILTER = '/candidatefilter/api/v1/ml'
export const REACT_APP_TIMESHEET = '/timesheet/api/v1/ml'
export const REACT_APP_JOBFILTER = '/jobfilter/api/v1/ml'
